import { newsLetterValidationSchema, validateField as validateFieldFuc } from '../utils/validation.utils';
import i18n from '../utils/translations.utils';
import { articleClickedData, productClickedData, buyNowClickedData } from '../utils/feedback.utils';
import { Env } from '@stencil/core';
import { ProductDetailsType } from '../utils/types';
import axios from 'axios';

const t = i18n.getTranslation.bind(i18n);

let checkedValue;

export enum BIN_API {
  MIKMAK = 'mikmak',
  PRICESPIDER = 'pricespider',
}

let analyticsService = null;
// vto
const soldOut = variantId => {
  const btnClick = document.querySelector('aiba-app')?.shadowRoot?.querySelector(`.btn[data--prodc_id="${variantId}"]`) as any;
  btnClick.innerHTML = 'SOLD OUT';
  btnClick.innerText = 'SOLD OUT';
  btnClick?.classList?.add('disabled');
  const varientClick = document.querySelector('aiba-app')?.shadowRoot?.querySelector(`.btn[data-varientid="${variantId}"]`) as any;
  varientClick?.classList?.add('disabled');
};

export const handleResultScreenOnLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const hideNewsletter = await handlers.getNewsletterSkipStatus();
    const utmsPresent = await handlers.getUTMsPresent();

    if ((window as any)?.subscribe) {
      (window as any)?.subscribe('cart-error', (event: any) => {
        soldOut(event?.productVariantId);
      });
    }

    return {
      hideNewsLetterOnAuthentication: utmsPresent || !hideNewsletter,
    };
  }
};

export const modalHandleClick = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    await handlers.setNewsletterSkipStatus(false);
  }
};

export const handleResultDidLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    let startTime;
    function focusElement(timestamp) {
      const inputElem = document
        .querySelector('aiba-app')
        ?.shadowRoot?.querySelector('.newsletter-container .newsletter-container__inputs aiba-input:nth-child(4) .input') as HTMLElement;
      inputElem?.classList?.remove('input');
      if (!startTime) {
        startTime = timestamp;
      }
      const elapsedTime = timestamp - startTime;
      if (elapsedTime < 1000) {
        requestAnimationFrame(focusElement);
      }
    }
    requestAnimationFrame(focusElement);
  }
};
export const handleRecommendedProductsOnLoad = async data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let responseWithSections = await handlers.getRecommendedProductsFromState();

    const finalProList = await responseWithSections.map(item => {
      item?.variants?.map(variant => {
        if (variant?.price) {
          if (variant?.compare_at_price) {
            let discountPrice = variant?.compare_at_price - variant.price;
            let discountPercent = Math.round((discountPrice / variant.compare_at_price) * 100);
            variant['discountPercent'] = `${discountPercent}% OFF`;
            const priceElement = `<span class="discount-price">₹${variant.price}</span><span class="actual-price">₹${variant?.compare_at_price}</span><span class="discount-percentage">${variant?.discountPercent}</span>`;
            variant['priceToDisplay'] = priceElement;
          } else {
            const priceElement = `<span class="discount-price">₹${variant.price}</span>`;
            variant['priceToDisplay'] = priceElement;
          }

          return variant;
        }
      });
      return item;
    });

    finalProList.map(item => {
      item.shortDescription = item.description;
      item?.variants?.map(variant_data => {
        if (variant_data?.inventory_quantity === 0) {
          variant_data.disabled = true;
          item.disabled = true;
        }
      });
    });

    data['list'] = finalProList;
    //binInit for PS

    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;

    if (buyItNow.api === BIN_API.PRICESPIDER) {
      handlePSonLoad(data['list'], buyItNow.api);
      const bin = await handlers.binService.getBinApi(buyItNow.api);

      const args = {
        ps_key: Env.API_KEY_PRICE_SPIDER,
        ps_language: buyItNow[buyItNow.api].language,
        ps_country: buyItNow[buyItNow.api].country,
        ps_url: buyItNow[buyItNow.api].url,
        ps_trackUrl: buyItNow[buyItNow.api].trackUrl,
        ps_versionUrl: buyItNow[buyItNow.api].versionUrl,
      };

      await bin.binInit(...Object.values(args));
    }

    if (buyItNow.api === BIN_API.MIKMAK) {
      let mikMakElement, binInitElement;
      binInitElement = data['elements'].find(item => item.name === 'aiba-bin-init');
      if (binInitElement) {
        mikMakElement = binInitElement.data.product.data['elements'].find(item => item.name === 'aiba-mik-mak');
      }

      if (mikMakElement) {
        let appId = Env[buyItNow[buyItNow.api].appId];
        mikMakElement['data'] = {
          ...buyItNow[buyItNow.api],
          appId,
        };
      }
    }

    analyticsService = handlers.analyticsService;

    await analyticsService?.registerEvent('event1', { page: 'vto recommended product screen' });

    const customProductsEvent = {};
    customProductsEvent['data'] = data['list'];
    await analyticsService?.registerEvent('event11', customProductsEvent);
    const feedbackBaseData = await getFeedbackData();
    sendFeedback(feedbackBaseData);
    return data;
  }
};

export const handlePSonLoad = (productList: ProductDetailsType[], binProvider: string) => {
  document.querySelector('.aiba-element-wrapper') && document.querySelector('.aiba-element-wrapper').remove();
  if (binProvider === BIN_API.PRICESPIDER) {
    const psWrapper = document.createElement('div');
    psWrapper.classList.add('aiba-element-wrapper', 'hidden');
    psWrapper.style.display = 'none';
    document.body.appendChild(psWrapper);
    productList.forEach((productData: ProductDetailsType) => {
      console.info('productData', productData);
      const psButton = document.createElement('div');
      psButton.classList.add('ps-widget');
      // psButton.setAttribute('ps-sku', productData.smartProductId);
      // psButton.setAttribute('id', `product-${productData.smartProductId}`);
      psButton.setAttribute('ps-sku', '079400474483');
      psButton.setAttribute('id', `product-${'079400474483'}`);
      document.querySelector('.aiba-element-wrapper').appendChild(psButton);
    });
  }
};

export const handleRecommendedArticlesOnLoad = async data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    data['articles'] = await handlers.getRecommendedArticlesFromState();
    return data;
  }
};

//feedback handlers

async function formatFeedbackResponse() {
  let productFeedback = [];
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const recommendedProducts = await handlers.getRecommendedProductsFromState();
    if (recommendedProducts) {
      productFeedback = recommendedProducts.map(recommendedProduct => ({
        productId: recommendedProduct.smartProductId || 'NA',
        productRoutine: recommendedProduct.routineName || 'NA',
        productClicked: false,
        buyNowClicked: false,
        productInView: false,
      }));
    } else {
    }
    // let articleFeedback = [];
    // const recommendedArticles = await handlers.getRecommendedArticlesFromState();
    // if (recommendedArticles) {
    //   articleFeedback = recommendedArticles.map(recommendedArticle => ({
    //     articleId: recommendedArticle.id,
    //     articleClicked: false,
    //     articleInView: false,
    //   }));
    // } else {
    //   console.error('null state.recommendedArticles');
    // }

    return { products: productFeedback };
  }
}

export async function getFeedbackData() {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const { brand, locale, division } = config.brand;
    let quizAnalysisResults = await handlers.getQuizAnalysisResultsFromState();

    quizAnalysisResults = quizAnalysisResults.flat(1).filter(item => item);
    const profile = await handlers.getUserProfile();

    const formatFeedbackFullData = await handlers.getQuizPayload();
    const formatFeedback = JSON.parse(JSON.stringify(formatFeedbackFullData));
    formatFeedback.map(i => {
      i.answers.forEach(data => {
        delete data.surveyQuestionAnswerId;
        delete data?.conditionalValue;
      });
    });

    return {
      meta: {
        brand,
        division,
        locale,
        username: profile.username ? profile.username : 'NA', //state.userProfile.username,
      },
      results: {
        quiz: formatFeedback,
      },
      feedback: await formatFeedbackResponse(),
    };
  }
}

export const sendFeedback = async feedbackData => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let feedbackService = handlers.feedbackService;
    const config = await handlers.getConfig();
    const apiDetails = config.apiConfig;
    const apiUrl = `${Env[apiDetails.baseUrl]}${Env[config.apiConfig.apiEndpoints.feedback]}`;
    const apikey = `${Env[apiDetails.apiKey]}`;
    (await feedbackService.getFeedbackInstance('feedbackML')).sendFeedback(feedbackData, apiUrl, apikey);
  }
};

export const handleLearnMoreClick = async (productDetail: any, event: Event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const feedbackBaseData = await getFeedbackData();
    const productID = productDetail?.smartProductId;
    const feedbackData = productClickedData(productID, feedbackBaseData);
    sendFeedback(feedbackData);
    console.log(event, 'product-wrapper__product__link');
  }
};

export const handleBinInit = async (event: Event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;
    const bin = await handlers.binService.getBinApi(buyItNow.api);

    if (buyItNow.api === BIN_API.PRICESPIDER) {
      const recommendedProducts = await handlers.getRecommendedProducts();
      const psWrapper = document.createElement('div');
      psWrapper.classList.add('aiba-element-wrapper', 'hidden');
      psWrapper.style.display = 'none';
      document.body.appendChild(psWrapper);
      recommendedProducts.forEach(item => {
        const psButton = document.createElement('div');
        psButton.classList.add('ps-widget');
        psButton.setAttribute('ps-sku', item.smartProductId);
        psButton.setAttribute('id', `product-${item.smartProductId}`);
        document.querySelector('.aiba-element-wrapper').appendChild(psButton);
      });

      const args = {
        ps_key: Env.API_KEY_PRICE_SPIDER,
        ps_language: buyItNow[buyItNow.api].language,
        ps_country: buyItNow[buyItNow.api].country,
        ps_url: buyItNow[buyItNow.api].url,
        ps_trackUrl: buyItNow[buyItNow.api].trackUrl,
        ps_versionUrl: buyItNow[buyItNow.api].versionUrl,
      };

      await bin.binInit(...Object.values(args));
    } else if (buyItNow.api === 'cartwire') {
      await bin.binInit(buyItNow[buyItNow.api].url);
    }

    console.log('@AIBA[handleBinInit]', event);
  }
};

const isPriceSpiderButtonVisible = dataValue => {
  return document.querySelector(`[ps-sku='${dataValue}']`).className.split(' ').includes('ps-enabled');
};

const binWidget = async (event: Event, smartId, product) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const target = event.currentTarget;
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;
    const bin = await handlers.binService.getBinApi(buyItNow.api);
    target['dataset']['value'] = smartId;
    await bin.binClick(target, buyItNow[buyItNow.api].theme, buyItNow[buyItNow.api].locale);
    event['data'] = {
      identifierValue: product['identifierValue'] || '',
      productName: product['productName'] || '',
      brand: product['brandName'] || '',
      category: product['category'] || '',
      size: product['size'] || '',
    };
    const feedbackBaseData = await getFeedbackData();
    const feedbackData = buyNowClickedData(smartId, feedbackBaseData);
    sendFeedback(feedbackData);
    analyticsService?.registerEvent('event38', event);
  }
};
export const getEventData = (event, product) => {
  const variantsButton = event.target.closest('.product-wrapper__product').querySelector('.product-wrapper__product-info .variants-button');
  const children = variantsButton?.children;
  let variantValue;
  let price;
  for (let i = 0; i < children?.length; i++) {
    const child = children[i];
    if (child?.children[0]?.classList?.contains('active')) {
      variantValue = child?.children[0]?.innerText;
    }
  }
  product?.variants?.map(variant => {
    if (variant?.title === variantValue) {
      price = variant.price;
    }
  });

  const arr = [];
  arr['identifierValue'] = product.identifierValue || '';
  arr['productName'] = product.productName || '';
  arr['brandName'] = product['brandName'] || '';
  arr['category'] = product['category'] || '';
  arr['qty'] = 1;
  arr['price'] = price || '';
  arr['smartProductId'] = '';
  arr['size'] = variantValue;

  return arr;
};
const getMaxItem = async () => {
  try {
    const res = await axios({
      method: 'get',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      url: '/cart.js',
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const handleBinClick = async (event: Event, smartId, product) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const dataValue = smartId;
    const btnClick: any = event.currentTarget;
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;
    const product_id = btnClick.dataset.Prodc_id;

    if (buyItNow['api'] === BIN_API.PRICESPIDER) {
      if (typeof (window as any).PriceSpider !== 'undefined' && typeof (window as any).PriceSpider.rebind !== 'undefined') {
        (window as any).PriceSpider.rebind();
      }

      if (isPriceSpiderButtonVisible(dataValue)) {
        await binWidget(event, smartId, product);
      } else {
        const waitForPriceSpider = setInterval(() => {
          if (isPriceSpiderButtonVisible(dataValue)) {
            if (typeof (window as any).PriceSpider !== 'undefined' && typeof (window as any).PriceSpider.rebind !== 'undefined') {
              (window as any).PriceSpider.rebind();
            }
            btnClick.click();
            clearInterval(waitForPriceSpider);
          }
        }, 100);
      }
    } else if (buyItNow['api'] === 'shopify') {
      event['data'] = [];
      event['data'].push(getEventData(event, product));
      await analyticsService?.registerEvent('scAdd', event);
      let prod_id;
      if (product_id) {
        prod_id = product_id;
      } else {
        prod_id = product.variants[0].id;
      }
      let response = await getMaxItem();
      let count;
      const foundId = response?.data?.items?.find(item => item.id === Number(prod_id));
      if (!foundId) {
        count = 0;
      } else {
        count = foundId?.quantity;
      }
      if (count === (window as any)?.theme?.MaxLimit) {
        const parentElement = document.querySelector('aiba-app')?.shadowRoot?.querySelectorAll('.bin-view-wrapper__bin-button .btn') as any;

        const checkingDiv = btnClick.closest('.product-wrapper__product').querySelector('.bin-view-wrapper__bin-button #errorId') as any;

        parentElement?.forEach(elem => {
          if (elem.dataset.Prodc_id === product_id && !checkingDiv) {
            const newDiv = document.createElement('div');
            newDiv.setAttribute('id', 'errorId');
            newDiv.textContent = 'You have reached the limit';
            newDiv.style.color = 'white';
            newDiv.style.padding = '10px';
            newDiv.style.textAlign = 'center';
            elem.parentElement.appendChild(newDiv);
          }
        });
      } else {
        const checkingDiv = btnClick.closest('.product-wrapper__product').querySelector('.bin-view-wrapper__bin-button #errorId') as any;
        checkingDiv && checkingDiv.remove();
        (window as any).getCart(prod_id, product?.identifierValue);
      }
    } else {
      await binWidget(event, smartId, product);
    }
  }
};

// export const getCart = async (product_id, product_details) => {
//   try {
//     const res = await axios({
//       method: 'get',
//       responseType: 'json',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//       },
//       url: '/cart.js',
//     });
//     console.log('shopify-response', res);
//     await shopifyCartUpdate(product_id, product_details);
//   } catch (error) {
//     throw error;
//   }
// };

// export const shopifyCartUpdate = async (product_id, product_details) => {
//   let prod_id;
//   if (product_id) {
//     prod_id = product_id;
//   } else {
//     prod_id = product_details.variants[0].id;
//   }
//   const formData = new FormData();
//   formData.append('form_type', 'product');
//   formData.append('utf8', '✓');
//   formData.append('id', prod_id); //id node in varients data
//   formData.append('product-id', JSON.parse(product_details.identifierValue)); // identifier value
//   formData.append('section-id', 'template--16374406381776__76b8e75a-520f-4575-ad59-e0554b36e2f7');
//   formData.append('sections', 'cart-drawer,cart-icon-bubble');
//   formData.append('sections_url', '/');

//   try {
//     const url = '/cart/add';
//     const headers = {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json',
//     };
//     const res = await axios.post(url, formData, {
//       responseType: 'json',
//       headers: headers,
//     });
//     console.log('shopify-response', res);
//     await displayCart();
//   } catch (error) {
//     throw error;
//   }
// };

// export const displayCart = async () => {
//   console.log(`[bin.shopify.api]:widget triggred`);
//   try {
//     const res = await axios({
//       method: 'get',
//       responseType: 'text',
//       headers: {
//         'Content-Type': 'text/html',
//       },
//       url: '/cart?section_id=cart-drawer',
//     });
//     console.log('shopify-response', res);
//     await openCart();
//   } catch (error) {
//     throw error;
//   }
// };

// export const openCart = async () => {
//   try {
//     const res = await axios({
//       method: 'get',
//       responseType: 'json',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//       },
//       url: '/cart.js',
//     });
//     console.log('shopify-response', res);
//     let quantity;
//     if (res?.data?.items[0]?.quantity) {
//       quantity = res?.data?.items[0]?.quantity;
//     } else {
//       quantity = 1;
//     }
//     await changeCart(quantity);
//   } catch (error) {
//     throw error;
//   }
// };
// export const changeCart = async quantity => {
//   try {
//     const item = {
//       line: '1',
//       quantity: JSON.stringify(quantity),
//       sections: ['cart-drawer', 'cart-icon-bubble'],
//       sections_url: '/',
//     };
//     const res = await axios({
//       method: 'post',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//       },
//       data: item,
//       url: '/cart/change',
//     });
//     console.log('shopify-response', res);
//   } catch (error) {
//     throw error;
//   }
// };

export const handleNavigationBlockButtonClick = async (event: Event, handlerName = '') => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    console.log(event, '@AIBA[navigation block button clicked]');
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;

    if (!handlerName) {
      document.getElementById('YMK-module')?.parentNode?.removeChild(document?.getElementById('YMK-module'));
      await handlers.setRecommendedStyles('');
      await handlers.setStateRetakeJourney(true);
      await handlers.setNewsletterSkipStatus(false);
      let customEvent = {};
      customEvent['target'] = event.currentTarget;
      customEvent['target']['href'] = 'vto welcome screen';
      customEvent['target']['textContent'] = 'start Over';
      await analyticsService?.registerEvent('event2', { ...event, target: event.currentTarget });
      return await handlers.initState();
    } else if (handlerName === 'backToStyleHandler') {
      let customEvent = {};
      customEvent['target'] = event.currentTarget;
      customEvent['target']['href'] = 'vto recommended style screen';
      customEvent['target']['textContent'] = 'Back To styles';

      const handlers = window['AIBA']['utils'];
      analyticsService = handlers.analyticsService;
      await analyticsService?.registerEvent('event2', { ...event, target: event.currentTarget });
      await analyticsService.registerEvent('event1', { page: 'vto recommended style screen' });
      await handlers?.setStyleData({ foundId: '', index: '', id: '' });
      await handlers.setShowResultScreen(false);
    }
  }
};

export const handleArticleClicked = async (event: Event, articleDetail: any) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const articleID = articleDetail['id'];
    const feedbackBaseData = await getFeedbackData();
    const feedbackData = articleClickedData(articleID, feedbackBaseData);
    sendFeedback(feedbackData);
    const handlers = window['AIBA']['utils'];
    let analyticsService = handlers.analyticsService;

    let customEvent = {};
    if ((event.target as any).tagName === 'IMG') {
      customEvent['target'] = (event.currentTarget as any)?.children[0].children[0].children[0];
    } else {
      customEvent['target'] = event.target;
    }

    analyticsService?.registerEvent('event63', customEvent);
  }
};

export async function availableGender() {
  return {
    [await t('app.gender.male')]: 'M',
    [await t('app.gender.female')]: 'F',
    [await t('app.gender.other')]: 'O',
    [await t('app.gender.unkown')]: 'U',
  };
}

export async function supportedGender() {
  return Object.values(await availableGender());
}
export const exporthandleValidationNewsLetter = async value => {
  try {
    const result = await validateField('name', value, newsLetterValidationSchema);
    if (result.message) {
      let event = new CustomEvent('event-options-error', { detail: result.details[0].message });
      document.dispatchEvent(event);
    }
    return result;
  } catch (error) {
    console.error(error);

    return error;
  }
};

const processDataForV3Results = async (quiz, questions, skin) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];

    // selectedOptions - [[], [], ...] (is an array of arrays)
    // let selectedOptions = await handlers.getQuizOptionSelected();

    // let selectedOptionsValues = Object.values(selectedOptions);

    // let selectedOptionsFlat = selectedOptionsValues.flat(1);

    let { selectedOptionsWithId } = await handlers.getQuizState();

    let newQuiz, newQuestions, newSkin;

    const config1 = await handlers.getConfig();
    const config = JSON.parse(JSON.stringify(config1));
    const locale = config.brand.locale;
    const locale_name = locale.split('-');
    // let quizGroupIDs = ['yourHair', 'yourHairGoals'];

    if (quiz) {
      newQuiz = quiz.flat(2);
      newQuiz = newQuiz.filter(question => question);
      const quizArrayForSubmission = [];
      newQuiz.forEach(que => {
        const questionData: any = { ...que };
        // !questionData?.hide this value we are getting from the JSON. This condition and "hide" parameter from JSON needs to remove once we received the Id's for 2A and 3A questions for Tresemme IN
        if (selectedOptionsWithId[questionData?.questionId] && !questionData?.hide) {
          const answersIdArray = selectedOptionsWithId[questionData?.questionId];
          const answerData: any = JSON.parse(JSON.stringify(questionData?.answers));
          answerData?.forEach(answer => {
            const answer2: any = JSON.parse(JSON.stringify(answer));
            if (answersIdArray.includes(answer2?.answerId)) {
              quizArrayForSubmission.push({
                questionId: locale_name[1] == 'US' ? answer2.surveyQuestionAnswerId : questionData?.questionId,
                answers: [{ answerId: [answer2?.answerId], title: answer2.title }],
              });
            }
          });
        }
      });

      if (locale_name[1] == 'IN') {
        const groupedAnswers = quizArrayForSubmission.reduce((acc, curr) => {
          if (!acc[curr.questionId]) {
            acc[curr.questionId] = {
              questionId: curr.questionId,
              answers: [],
            };
          }
          acc[curr.questionId].answers.push({
            answerId: curr.answers[0].answerId,
            title: curr.answers[0].title,
          });
          return acc;
        }, {});
        const consolidatedObject = Object.values(groupedAnswers);

        newQuiz = [...consolidatedObject];
      } else {
        newQuiz = [...quizArrayForSubmission];
      }
    }
    if (questions) {
      newQuestions = questions;
    }

    if (skin) {
      newSkin = skin;
    }
    return { newQuiz, newQuestions, newSkin };
  }
};

export const handleNewsLetterCheckBox = async (checked, event) => {
  console.log('@AIBA[handleNewsLetterCheckBox]', event);

  checkedValue = checked;
};

export const handleMikMaKBuyNowClick = async (product: any, event: any) => {
  event['data'] = {
    identifierValue: product['identifierValue'] || '',
    productName: product['productName'] || '',
    brand: product['brandName'] || '',
    category: product['category'] || '',
    size: product['size'] || '',
  };
  const feedbackBaseData = await getFeedbackData();
  const feedbackData = buyNowClickedData(product?.smartProductId, feedbackBaseData);
  sendFeedback(feedbackData);
  analyticsService?.registerEvent('event38', event);
};

export const handleVideoDidLoad = (videoId, element, videoApi) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    let videoService = handlers.videoService;
    if (videoId) {
      videoService.videoPlayer(videoId, element, videoApi, analyticsService, Env.YOUTUBE_API_URL);
    }
  }
};

export const handleNewsLetterSubmit = async (event, formdata) => {
  event.preventDefault();
  let api;
  let header;
  let locale;
  let brand;
  let profileStore;
  let config_getSelectedStyles;
  let config_getStylesIdMappingList;
  const results = {
    quiz: [],
    questions: [],
  };
  checkedValue = true; // We dont have checkbox, the default will be true
  let name = '';
  const brandEmailConsentOptinsDetails: any = [];

  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const resultQuizData = await handlers.getQuizAnalysisResultsFromState();
    const resultQuestionsData = await handlers.getQuizAnalysisResultsFromState();

    const { newQuiz, newQuestions } = await processDataForV3Results(resultQuizData, resultQuestionsData, null);

    if (newQuiz) results.quiz = newQuiz;
    if (newQuestions) results.questions = newQuestions;
    // gender = await handlers.getGender();
    name = await handlers.getUserName();
    const config1 = await handlers.getConfig();
    const config = JSON.parse(JSON.stringify(config1));
    api = config.profileStore.api;
    header = config.profileStore[api].header;
    locale = config.brand.locale;
    brand = config.brand.brand;
    profileStore = config.profileStore;
    config_getSelectedStyles = config.getSelectedStyles;
    config_getStylesIdMappingList = config.getStylesIdMappingList;
    const locale_name = locale.split('-');

    //ADDING HAIR STYLES TO QUIZ
    const formattedStyleResults = await handlers.getStyle();
    let trackedstyles = [];
    trackedstyles['answers'] = [];
    let questionIdforTrackStyles;

    const mapping = config_getStylesIdMappingList;
    formattedStyleResults.trackstyles
      .filter(id => id !== 'original')
      .map(id1 => {
        if (locale_name[1] == 'US') {
          const { answerId, surveyQuestionAnswerId } = mapping[id1];
          results?.quiz?.push({
            questionId: surveyQuestionAnswerId,
            answers: [{ answerId: [answerId], title: id1 }],
          });
        } else {
          const { answerId, questionId } = mapping[id1];
          questionIdforTrackStyles = questionId;
          trackedstyles['answers'].push({
            answerId: [answerId],
            title: id1,
          });
        }
        return 1;
      });

    if (trackedstyles['answers']?.length != 0) {
      trackedstyles['questionId'] = questionIdforTrackStyles;
      results?.quiz?.push(trackedstyles);
    }

    //ADD LAST SELECTED STYLE

    const selectedStyle = config_getSelectedStyles[formattedStyleResults.selectedStyleId];

    results.quiz.push({
      questionId: locale_name[1] == 'US' ? selectedStyle.surveyQuestionAnswerId : selectedStyle.questionId,
      answers: [{ answerId: [selectedStyle.answerId], title: formattedStyleResults.selectedStyleId }],
    });

    const additionalSubscription = config.profileStore[api].additionalSubscription;
    if (additionalSubscription?.brandEmailConsentOptins) {
      brandEmailConsentOptinsDetails.push({ serviceId: additionalSubscription?.brandEmailConsentOptins, optIn: checkedValue });
    }
    if (additionalSubscription?.unileverEmailConsentOptins) {
      brandEmailConsentOptinsDetails.push({ serviceId: additionalSubscription?.unileverEmailConsentOptins, optIn: checkedValue });
    }

    if (additionalSubscription?.healthConsentOptins) {
      brandEmailConsentOptinsDetails.push({ serviceId: additionalSubscription?.healthConsentOptins, optIn: checkedValue });
    }

    const tempKey = profileStore[api]['apiKey'];

    profileStore[api]['apiKey'] = Env[tempKey];
  }
  event.results = { ...results };

  const profileData = {
    contactDetail: {
      email: formdata.email,
    },
    consumerIdentity: {
      firstName: formdata.firstName ? formdata.firstName : name,
      lastName: formdata.lastName ? formdata.lastName : name,
      dateOfBirth: formdata.dob ? formdata.dob : null,
    },
    consent: {
      legalAgeConsent: checkedValue,
    },
    results,
  };
  const market = locale.split('-');
  if (market[1].toLowerCase() !== 'us') {
    profileData['consent']['unileverEmailConsent'] = checkedValue;
  }
  if (brandEmailConsentOptinsDetails?.length > 0) {
    profileData['additionalSubscription'] = brandEmailConsentOptinsDetails;
  }
  formdata.formSubmission = true;
  const availableGenderArray = await availableGender();
  const supportedGenderArray = await supportedGender();
  const genderArray = {
    availableGenderArray,
    supportedGenderArray,
  };

  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;

    await analyticsService?.registerEvent('event2', { ...event, target: event.currentTarget });

    let response;
    response = await handlers.profileService.saveProfile(profileData, api, header, locale, brand, profileStore, genderArray).catch(error => error);
    if (!response) {
      response = {
        data: {
          status: '200',
          downstreamApiResponse: '',
        },
      };
      response['status'] = 200;
    }
    if (response && response.status === 202) {
      response.data.downstreamApiResponse = response.data.status;
      await analyticsService.registerEvent('event58', {
        data: 'Successful Sign Up',
        brandOptin: checkedValue,
        component: 'newsletter signup',
      });
      if (checkedValue) {
        const customEvent = {
          data: {
            brandOptIn: ['brandEmailConsent optin', 'legalAgeConsent optin', 'unileverEmailConsent optin'],
          },
        };
        await analyticsService?.registerEvent('event50', customEvent);
      } else {
        await analyticsService?.registerEvent('event62', {
          data: { brandOptOut: ['brandEmailConsent', 'legalAgeConsent', 'unileverEmailConsent'] },
        });
      }
      const modalPopup = document.querySelector('aiba-app')?.shadowRoot?.querySelector('aiba-newsletter .modal-block') as any;
      if (modalPopup) modalPopup.style.display = 'none';
      (document.querySelector('body') as any).style.overflow = 'auto';
      const secondBlock = document.querySelector('aiba-app')?.shadowRoot?.querySelector('.result-screen aiba-newsletter .newsletter-container:nth-child(1)') as any;
      secondBlock.style.display = 'block';
      return true;
    }
  }
};

export const genericBlockWillLoadhandler = async (data: any) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const vtoState = await handlers.getVtoState();

    const data1 = [...vtoState.recommendedStyles[0].other, ...vtoState.recommendedStyles[0].recommendation];

    const selectedStyle = await handlers.getStyle();
    const result = data1.reduce((total, curr) => {
      const current = curr;
      const styleId = selectedStyle.selectedStyleId;
      if (current.id === styleId) {
        total = current;
      }
      return total;
    }, {});

    const collectionData = result;
    let helix_image;
    await data?.elements?.map(async item => {
      if (item.data._id == 'collection-video-1') {
        item.data.videoId = collectionData.youtubevideo;
        const previewImageUrl = Env.YOUTUBE_PREVIEW_IMAGEURL;
        item.data.previewImageUrl = previewImageUrl.replace('<videoid>', collectionData?.['youtubevideo']);
        helix_image = item.data;
        if (!item?.data?.videoId) {
          item.data = undefined;
        }
        const dynamicData = {
          'aiba-hero-image': { 'collection-video-1': helix_image },
        };
        return dynamicData;
      }
    });
  }
};

export const generatePdf = async (recommendedProducts, name, email, brandinfo, generatePdfWithContent) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    try {
      const config = await handlers.getConfig();
      const hairAnalysisResultsForViewArr = [];
      const hairAnalysisResultsArr = [];

      const templateurrls = key => {
        const urls = {
          footer: 'https://aiba-uat.unileversolutions.com/beautyhub/en-ph/v1/pdf-footer-template.html',
          header: 'https://aiba-uat.unileversolutions.com/beautyhub/en-ph/v1/pdf-header-template.html',
          mail: 'https://aiba-uat.unileversolutions.com/beautyhub/en-ph/v1/mail-template.json',
          body: 'https://aiba-uat.unileversolutions.com/beautyhub/en-ph/v1/pdf-template.html',
        };
        return urls[key];
      };
      const data = await generatePdfWithContent(
        {
          recommendedProductsOthers: recommendedProducts,
          hairAnalysisResults: hairAnalysisResultsArr,
          hairAnalysisResultsForView: hairAnalysisResultsForViewArr,
          topConcerns: [],
          name: name ? name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : t('newsletter-signup-pdf-mailer-defaultName'),
          emailId: email,
          brandname: brandinfo.brandname,
          bransiteurl: brandinfo.bransiteurl,
          bransite: brandinfo.bransite,
          brandphoneNumber: brandinfo.brandphoneNumber,
        },
        templateurrls,
        `${Env.AIBA_SERVICES_BASE_URL}${Env[config.apiConfig.apiEndpoints.pdfmailer]}`,
        Env.API_KEY_AIBA_SERVICES,
      );
      return data;
    } catch (error) {
      console.error('[newsletter-signup.pdfGenaration.error] ', error);
    }
  }
};
export const getNewsLetterSchema = () => {
  return newsLetterValidationSchema;
};

export const handleNewsLetterLinkClick = async (href, event: Event) => {
  console.log(href, '@AIBA[handleNewsLetterLinkClick]');
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers.analyticsService;
  analyticsService?.registerEvent('event2', event);
};

export const handleFirstInteractionNewsletter = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    const customEvent = { data: 'newsletter signup start', component: 'newsletter signup' };
    analyticsService.registerEvent('event57', customEvent);
  }
};

export const productDidLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const activeButtonElement = document.querySelector('aiba-app')?.shadowRoot?.querySelectorAll('.product-wrapper__product-info .variants-button .active');
    activeButtonElement.forEach(element => {
      handlers.variantsDidLoad = true;
      (element as HTMLElement).click();
    });
    handlers.variantsDidLoad = false;
  }
};

export const handleVarientsClick = async (event, prod_variants) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const priceDiv = event?.target?.closest('.product-wrapper__product-info')?.querySelector('.variant-price .label-wrapper--p') as HTMLElement;
    const imageDiv = event?.target?.closest('.product-wrapper__product')?.querySelector('.product-wrapper__product__img img') as HTMLElement;
    const addToCartDiv = event?.target?.closest('.product-wrapper__product')?.querySelector('.bin-view-wrapper .btn') as HTMLElement;
    const errorBtn = event?.target?.closest('.product-wrapper__product')?.querySelector('.bin-view-wrapper #errorId') as HTMLElement;
    if (errorBtn) {
      errorBtn?.remove();
    }

    const clickedElement = event.target;
    const parentDiv = clickedElement.closest('.variants-button');
    const children = parentDiv.children;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child?.children[0]?.classList?.contains('active') && !handlers?.variantsDidLoad) {
        child?.children[0]?.classList?.remove('active');
      }
    }
    clickedElement.classList.add('active');

    addToCartDiv.dataset.Prodc_id = prod_variants.id;
    const btnClick = document.querySelector('aiba-app')?.shadowRoot?.querySelector(`.btn[data--prodc_id="${prod_variants.id}"]`) as any;
    if (prod_variants?.disabled) {
      btnClick?.setAttribute('disabled', 'true');
      btnClick.innerHTML = 'SOLD OUT';
      btnClick.innerText = 'SOLD OUT';
    } else {
      btnClick?.removeAttribute('disabled');
      btnClick?.classList?.remove('disabled');
      btnClick.innerHTML = 'ADD TO CART';
      btnClick.innerText = 'ADD TO CART';
    }
    priceDiv.innerHTML = prod_variants.priceToDisplay;
    priceDiv.innerHTML = await prod_variants.priceToDisplay;
    if (prod_variants?.var_image) {
      imageDiv.setAttribute('src', prod_variants?.var_image);
    }
  }
};

export const handleShareButtonClick = async (event, data) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    window.open(data.pageUrl);
    event.target['dataset']['product'] = JSON.stringify(data);
    await analyticsService?.registerEvent('event12', event);
  }
};

export const closeConfirmModalhandler = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    await analyticsService?.registerEvent('event2', { target: { textContent: 'skip', href: 'vto recommended product screen' } });
  }
};

export const formErrorhandler = errorMessage => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    analyticsService?.registerEvent('event32', { label: 'signup error ', error: errorMessage });
  }
};

export const validateField = validateFieldFuc;
